/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.hint-message-drag[_ngcontent-%COMP%] {\n  text-align: right;\n  padding: 8px; }\n\n.text-info[_ngcontent-%COMP%] {\n  width: 100%; }\n\n.hidden[_ngcontent-%COMP%] {\n  display: none; }\n\n.typeRequisition[_ngcontent-%COMP%] {\n  margin-top: 11px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvc3luZXJnby9zeW5lcmdvLWNpdGF0aW9ucy9zeW5lcmdvLW5ldy1jaXRhdGlvbi9zeW5lcmdvLW5ldy1jaXRhdGlvbi5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvbW9kdWxlcy9lbXBsb3llZS9wYWdlcy9zeW5lcmdvL3N5bmVyZ28tY2l0YXRpb25zL3N5bmVyZ28tbmV3LWNpdGF0aW9uL3N5bmVyZ28tbmV3LWNpdGF0aW9uLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/synergo/synergo-citations/synergo-new-citation/synergo-new-citation.component.scss.shim.ngstyle.ts